import { render, staticRenderFns } from "./CompaniesYandexrentPage.vue?vue&type=template&id=4fc3d40b&scoped=true"
import script from "./CompaniesYandexrentPage.vue?vue&type=script&lang=js"
export * from "./CompaniesYandexrentPage.vue?vue&type=script&lang=js"
import style0 from "./CompaniesYandexrentPage.vue?vue&type=style&index=0&id=4fc3d40b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc3d40b",
  null
  
)

export default component.exports